import { Pipe, PipeTransform } from '@angular/core';

import { MemberLike } from '@component/team';
import { EntityMemberRoleType } from '@state/entities';

@Pipe({
  name: 'isPrimaryContact'
})
export class IsPrimaryContactPipe implements PipeTransform {
  transform(member: MemberLike): boolean {
    return member?.entity_member_roles?.some(
      (memberRole) => memberRole.role === EntityMemberRoleType.PrimaryContact
    );
  }
}
